import { render, staticRenderFns } from "./ReviewUpLimitUp.vue?vue&type=template&id=88336be4"
import script from "./ReviewUpLimitUp.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimitUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports